export default "__VITE_ASSET__xWGQcJ78__"